<template>
    <div class="input-number">
        <i class="iconfont  minus" @click="minus" :class="selectIcon === true ? 'icon-minus' : 'icon-arrow-left'"></i>
        <i class="iconfont  plus" @click="plus" :class="selectIcon === true ? 'icon-plus' : 'icon-arrow-right'"></i>
        <div class="input">
            <input type="text" :value="defaultValue" autocomplete="off" disabled @blur="checkNumber">
        </div>
    </div>
</template>
<script>
    export default {
        name: 'input-number',
        data() {
            return {
                defaultValue: 0
            }
        },
        props: {
            value: {
                type: Number,
                default: 1
            },
            max: {
                type: Number,
                default: 5
            },
            min: {
                type: Number,
                default: 0
            },
            step: {
                type: Number,
                default: 1
            },
            selectIcon:{
                type:Boolean,
                default:true
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    let newVal = Number(value);
                    if (isNaN(newVal)) return;
                    if (newVal >= this.max) newVal = this.max;
                    if (newVal <= this.min) newVal = this.min;
                    this.defaultValue = newVal;
                    this.$emit('input', newVal);
                }
            }
        },
        methods: {
            checkNumber() {
                if (parseInt(this.defaultValue) !== 'NaN') {
                    this.defaultValue = parseInt(this.defaultValue)
                    return
                }
                this.defaultValue = this.value
            },
            minus() {
                this.computNumber(false)
                this.$emit('minus')
            },
            plus() {
                this.computNumber(true)
                this.$emit('plus')
            },
            computNumber(c = false) {
                if (c) {
                    if (this.defaultValue < this.max) {
                        this.defaultValue += this.step
                    }
                } else {
                    if (this.defaultValue > this.min) {
                        this.defaultValue -= this.step
                    }
                }
                this.$emit('input', this.defaultValue)
            }

        }
    }
</script>
<style scoped lang="scss">
    @import "../sass/fonts/iconfont.css";
    @import "../sass/variables";

    .input-number {
        position: relative;
        display: inline-block;
        max-width: 80px;
        line-height: 20px;
        & > i {
            position: absolute;
            z-index: 1;
            top: 1px;
            width: 20px;
            height: 20px;
            text-align: center;
            background: $gray-500;
            color: $gray-200;
            cursor: pointer;
            font-size: 12px;
            border-radius: 2px;
            &:hover {
                color: $light-blue;
            }
            &.minus {
                left: 1px;
            }

            &.plus {
                right: 1px;
                color: $light-blue;
            }
        }
        .input {
            position: relative;
            font-size: 16px;
            display: block;
            width: 100%;
            input {
                text-align: center;
                -webkit-appearance: none;
                background-color: #fff;
                background-image: none;
                box-sizing: border-box;
                color: #606266;
                display: inline-block;
                font-size: inherit;
                height: 20px;
                line-height: 20px;
                outline: none;
                padding: 0 20px;
                transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Inputnumber.vue